// if seoObject = null instead of undefined, using a default argument when unpacking won't work
// so do a manual check here
const getLanguageCode = (seoObject) => {
  if (seoObject && seoObject.languageCode) {
    return seoObject.languageCode;
  }

  return 'en';
};

const extractNodes = (queryResult, collectionName) => (
  queryResult.data[collectionName].edges.map(edge => edge.node)
);

module.exports = {
  getLanguageCode,
  extractNodes,
};
